
import React from 'react';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

const Tab = (props) => {

    const classNames = mergeStyleSets({
        root: {
            padding: '8px',
            cursor: (props.active) ? 'default' : 'pointer',
            color: (props.active) ? '#000000' : '#aaaaaa',
            selectors: {
                ':hover': {
                    color: '#000000'
                }
            }
        },
        icon: {
            fontSize: 24,
            height: 24,
            width: 24,
            margin: '0 0 0 0'
        }
    });

    const onClick = () => {
        if (!props.active && props.onClick) {
            props.onClick(props);
        }
    };

    return (
        <div className={classNames.root} onClick={onClick}>
            <FontIcon
                iconName={props.iconName}
                className={classNames.icon}
                title={props.title}
            />
        </div>
    );
}

export default Tab;
